import React from "react";
import { Row, Col, Spin } from "@murm/ant";
import { CategoryButton } from "../components/CategoryButton";
import { FeatureButton } from "../components/FeatureButton";
import { BackButton } from "../components/BackButton";
import { CARD_COLUMNS, orderedCategories } from "../config/catalogContent";
import { useFeatureNavigation } from "../../../lib/dataCatalog/useFeatureNavigation";
import { useFetchFeatures } from "../../../lib/useFetchFeatures";
import { FeatureTypeConfig } from "../config/featureTypes";
import styles from "../DataCatalog.module.css";

const FiltersTab = ({ onFilterSelect, isItemSelected }) => {
  const {
    selectedCategory,
    selectedFeature,
    handleCategoryClick,
    handleFeatureClick,
    handleBack,
    handleDirectCategoryAndFeature,
    isDirectNavigation,
  } = useFeatureNavigation();

  // No in-catalog search box in the Explorer Figma (2a): every category is listed.
  const { categorizedFeatures: filteredFeatures, isLoading } = useFetchFeatures(
    "/api/config/filters"
  );

  const handleFilterSelection = (filterItem) => {
    onFilterSelect(filterItem);
  };

  const handleCategoryOrFeatureClick = (category, features) => {
    if (features.length === 1 && features[0].name === category) {
      handleDirectCategoryAndFeature(category, features[0]);
    } else {
      handleCategoryClick(category);
    }
  };

  if (isLoading) {
    return (
      <div className={styles.loading}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div className={styles.tabBody}>
      {selectedCategory && (
        <BackButton
          onClick={handleBack}
          backTarget={
            selectedFeature && !isDirectNavigation
              ? selectedCategory
              : "Categories"
          }
        />
      )}

      {!selectedCategory ? (
        <Row gutter={[12, 12]}>
          {orderedCategories(filteredFeatures).map(([category, features]) => (
            <Col key={category} {...CARD_COLUMNS}>
              <CategoryButton
                category={category}
                onClick={() => handleCategoryOrFeatureClick(category, features)}
              />
            </Col>
          ))}
        </Row>
      ) : !selectedFeature ? (
        <Row gutter={[12, 12]}>
          {filteredFeatures[selectedCategory]?.map((feature) => (
            <Col key={feature.name} {...CARD_COLUMNS}>
              <FeatureButton
                feature={feature.display || feature.name}
                description={feature.description}
                onClick={() => handleFeatureClick(feature)}
                selected={false}
              />
            </Col>
          ))}
        </Row>
      ) : (
        <Row gutter={[12, 12]}>
          {selectedFeature.values.map((value, idx) => {
            const config = FeatureTypeConfig["filter"];
            const filterItem = config.createFilterItem(
              selectedFeature,
              value,
              selectedFeature.display_values[idx]
            );
            const selected = isItemSelected(filterItem, "filters");
            return (
              <Col key={value} {...CARD_COLUMNS}>
                <FeatureButton
                  feature={selectedFeature.display_values[idx]}
                  description={selectedFeature.description}
                  onClick={() => handleFilterSelection(filterItem)}
                  selected={selected}
                />
              </Col>
            );
          })}
        </Row>
      )}
    </div>
  );
};

export { FiltersTab };
